import classNames from 'classnames';
import { times } from 'lodash-es';
import * as React from 'react';

import Icon from './Icon';

import css from './StarRating.module.scss';

interface Props {
  className?: string;
  rate: number;
  size?: StarRatingSize;
}

export enum StarRatingSize {
  Small = 'small',
  Medium = 'medium',
}

const StarRating = ({ className, rate, size }: Props) => {
  size = size || StarRatingSize.Small;
  const classes = classNames(css.StarRating, className, {
    [css.isMedium]: size === StarRatingSize.Medium,
  });
  const starClasses = (index: number) =>
    classNames(css.StarRating__Icon, index + 1 <= rate ? css.isActive : '');

  return (
    <span className={classes}>
      {times(5).map(index => (
        <span className={css.StarRating__Item} key={index}>
          <Icon name="star" className={starClasses(index)} />
        </span>
      ))}
    </span>
  );
};

export default StarRating;
